// Actions constants:
export const GET_MOVIE_DETAIL = 'GET_MOVIE_DETAIL';
export const CLEAR_MOVIE_DETAIL = 'CLEAR_MOVIE_DETAIL';
export const GET_SERIE_DETAIL = 'GET_SERIE_DETAIL';
export const CLEAR_SERIE_DETAIL = 'CLEAR_SERIE_DETAIL';
export const GET_SEASON_DETAIL = 'GET_SEASON_DETAIL';
export const GET_HOME_ALL = 'GET_HOME_ALL';
export const START_LOADING = 'START_LOADING';
export const GET_MOVIES = 'GET_MOVIES';
export const GET_TV_SHOWS = 'GET_TV_SHOWS';
export const GET_SEARCH = 'GET_SEARCH';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';
export const CLEAR_MOVIES = 'CLEAR_MOVIES';
export const CLEAR_GENRES = 'CLEAR_GENRES';
export const CLEAR_SERIES = 'CLEAR_SERIES';
export const GET_ALL_GENRES = 'GET_ALL_GENRES ';
export const GET_ALL_MOVIES = 'GET_ALL_MOVIES';
export const GET_MOVIE_GENRE_BY_ID = 'GET_MOVIE_GENRE_BY_ID';
export const ERROR_FOUND = 'ERROR_FOUND';
export const ERROR_CLEAN = 'ERROR_CLEAN';
export const GET_TV_SHOW_GENRES = 'GET_TV_SHOW_GENRES';
export const GET_SERIES_BY_GENRE = 'GET_SERIES_BY_GENRE';
export const RENT_VIDEO = 'RENT_VIDEO';
export const UPGRADE_PLAN = 'UPGRADE_PLAN';
export const LOG_IN = 'LOG_IN';
export const LOG_OUT = 'LOG_OUT';
export const GET_COMMENTS_DATA = 'GET_COMMENTS_DATA';
export const POST_COMMENT = 'POST_COMMENT';
export const DELETE_COMMENT = 'DELETE_COMMENT';
export const ADD_TO_WATCHLIST = 'ADD_TO_WATCHLIST';
export const CHANGE_NAME = 'CHANGE_NAME';
export const REMOVE_FROM_WATCHLIST = 'REMOVE_FROM_WATCHLIST';
export const DOWNGRADE_PLAN = 'DOWNGRADE_PLAN';
export const CHANGE_SID = 'CHANGE_SID';
export const UPLOAD_IMG = 'UPLOAD_IMG';
export const AVATAR_IMG = 'AVATAR_IMG';
export const LIKE = 'LIKE';
export const DISLIKE = 'DISLIKE';
export const GET_LIKES_FROM_USER = 'GET_LIKES_FROM_USER';
export const GET_LIKES_FROM_CONTENT = 'GET_LIKES_FROM_CONTENT';
export const ISLIKE = 'ISLIKE';
